export var FIRST_DAY = {
  en: 0,
  ru: 1,
  it: 0,
  es: 1,
  de: 1,
  zh: 0,
  el: 1
};
export var WEEKDAYS_SHORT = {
  en: ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'],
  ru: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  it: ['do', 'lu', 'ma', 'me', 'gi', 've', 'sa'],
  es: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  de: ['so', 'mo', 'di', 'mi', 'do', 'fr', 'sa'],
  zh: ['日', '一', '二', '三', '四', '五', '六'],
  el: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα']
};
export var WEEKDAYS_LONG = {
  en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  ru: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
  it: ['Domenica', 'Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato'],
  es: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  de: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Sonnabend'],
  zh: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
  el: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']
};
export var LABELS = {
  ru: {
    nextMonth: 'следующий месяц',
    previousMonth: 'предыдущий месяц'
  },
  en: {
    nextMonth: 'next month',
    previousMonth: 'previous month'
  },
  it: {
    nextMonth: 'il prossimo mese',
    previousMonth: 'mese precedente'
  },
  es: {
    nextMonth: 'el próximo mes',
    previousMonth: 'mes anterior'
  },
  de: {
    nextMonth: 'nächster monat',
    previousMonth: 'vorheriger monat'
  },
  zh: {
    nextMonth: '下个月',
    previousMonth: '前一个月'
  },
  el: {
    nextMonth: 'επόμενο μήνα',
    previousMonth: 'προηγούμενος μήνας'
  }
};
export var MONTHS = {
  ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
  en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  it: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
  es: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septriembre', 'Octubre', 'Noviembre', 'Diciembre'],
  de: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  zh: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
  el: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Ενδέχεται', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος']
};